import styled from 'styled-components'

export const SwitchContainer = styled.div`
display: flex;
gap: 0.5rem;
align-items: center;
`
